import React, { Component } from 'react';
import {connect} from 'react-redux';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import ThisStationTable from './ThisStationTable';
import PageWithSidebar from '../Layouts/PageWithSidebar';
import Config from '../../config';

class Outgoing extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      data: [],
    }

    this.updateOutgoing = this.updateOutgoing.bind(this);
  }
  
  componentDidMount() {
    this.updateOutgoing();
  }

  updateOutgoing() {
    const parameters = {
        headers: Config.api.getConfig().headers,
        params: {
          wheelChangerId: Config.api.getWheelChangerId()
        }
      }

      axios.get(Config.api.getDomain() + 'order/outgoing', parameters)
      .then(res => {
        this.setState({
          data: res.data
        })
      })
      .catch(error => {
        console.log(error);
      })
  }

  render() {
    return (
      <PageWithSidebar page={"orders outgoing"} location={this.props.location}>

        <h1>Utgående</h1>
        {
          this.state.data.length > 0 ? this.state.data.map((station, key) => {
            return (
              <ThisStationTable
                title={`Utgående till ${station.toContactInfo.name}`}
                key={key}
                data={station}
                updateTable={this.updateOutgoing}
              />
            )
          }) : null
        }

        {/* {
              this.state.data !== null ? this.state.data.outgoingStation.map((station, key) => {
                return (
                  <ThisStationTable
                    title='Utgående till stationsnamn'
                    key={key}
                    data={station}
                  />
                )
              }) : null
            } */}

      </PageWithSidebar>
    );
  }
}

/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
    return {
        Outgoing: () => dispatch(Outgoing())
    };
};

/**
 * Export Edit Employee
 */
export default connect(null, mapDispatchToProps)(Outgoing);


// WEBPACK FOOTER //
// ./src/components/Outgoing/index.js